import React from "react";
import Dispatcher from "../../dispatcher";
import BookStore from "../../stores/book-store";
import FractionStore from "../../stores/fraction-store";
import MainMenuMixin from "../ui_elements/main-menu-mixin";
import gadgets from "../gadgets/gadgets";
import { colors } from "chameleonjs";
import styled from "styled-components";

var ToolbarButton = require("../ui_elements/toolbar-button");
var Tooltip = require("../ui_elements/tooltip").Tooltip;
var TooltipMixin = require("../ui_elements/tooltip").TooltipMixin;
var Isvg = require("../../../vendor/react-inlinesvg");
var MenuMixin = require("../ui_elements/menu").MenuMixin;
var ContextModal = require("../ui_elements/context-modal").ContextModal;

const VerticalToolbarDiv = styled.div`
  background: ${props => colors[Fraction.Brand.Theme.base].getShade(10)};
  .toolbar-button:not(.home-button) {
    border-left: 0.4rem solid transparent;
    border-right: 0.4rem solid transparent;
    &:hover, &:focus {
      border-left: 0.4rem solid ${props =>
        colors[Fraction.Brand.Theme.base].getShade(4)};
    }
    &.active-highlight, &.active-highlight:hover {
      background-color: ${props =>
        colors[Fraction.Brand.Theme.base].getShade(9)} !important;
      border-left: 0.4rem solid ${props =>
        colors[Fraction.Brand.Theme.base].getShade(4)} !important;
    }
  }
`;

/*
  Renders the vertical toolbar
    props:
    state:
*/
class VerticalToolbarContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    // MainMenuMixin bindings
    this._toggleMainMenu = MainMenuMixin._toggleMainMenu.bind(this);
    this._menuOpen = MainMenuMixin._menuOpen.bind(this);
    this._menuClose = MainMenuMixin._menuClose.bind(this);
    this._menuRefocus = MainMenuMixin._menuRefocus.bind(this);

    // MenuMixin bindings
    this._toggleMenu = MenuMixin._toggleMenu.bind(this);
    this._showMenu = MenuMixin._showMenu.bind(this);
    this._removeMenu = MenuMixin._removeMenu.bind(this);
    this._redrawMenu = MenuMixin._redrawMenu.bind(this);

    // Method bindings
    this._fractionStoreChange = this._fractionStoreChange.bind(this);
    this._mobileMenuEvent = this._mobileMenuEvent.bind(this);
    this._pageReady = this._pageReady.bind(this);
    this._loadWatkins = this._loadWatkins.bind(this);
    this.tmpSearchEvent = this.tmpSearchEvent.bind(this);
    this._openSearch = this._openSearch.bind(this);
    this._howManyButtons = this._howManyButtons.bind(this);
    this._toggleDotMenu = this._toggleDotMenu.bind(this);
  }

  componentDidMount() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 3);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_LOAD, this._pageReady);
    Dispatcher.bind(
      Dispatcher.FRACTION_STORE_CHANGE,
      this._fractionStoreChange
    );
    gadgets.find(gadget => {
      gadget.active = false;
    });
  }

  componentWillUnmount() {
    Dispatcher.removeListener(Dispatcher.BOOK_PAGE_READY, this._pageReady);
    Dispatcher.removeListener(Dispatcher.BOOK_PAGE_LOAD, this._pageReady);
    Dispatcher.unbind(
      Dispatcher.FRACTION_STORE_CHANGE,
      this._fractionStoreChange
    );
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 3);
  }

  _fractionStoreChange() {
    this.forceUpdate();
  }

  // Fire this when the mobile menu button is clicked
  _mobileMenuEvent(e) {
    this._removeMenu();
    MainMenuMixin._toggleMainMenu(e, this.props.updatePowerByClass);
  }

  _pageReady(e, data) {
    this.forceUpdate();
  }

  _loadWatkins() {
    Fraction.Helpers.showModal(
      {
        title: "Watkins!",
        content: (
          <div style={{ width: "100%", height: "100%", overflow: "auto" }}>
            <div className="all-watkins">
              <img src="http://demo.vpg.com/jigsaw_demo/allwat.jpg" />
            </div>
          </div>
        ),
        closeCallback: this._removeDebugMenu,
        fullscreen: true
      },
      false,
      $("#reader-tools")
    );
  }

  tmpSearchEvent() {
    var element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  }

  _openSearch() {
    Dispatcher.emit(Dispatcher.SHOW_PANEL, "search");
  }

  render() {
    const book = BookStore.get(this.props.isbn);
    // Using slice(0) to clone the array to prevent modifying the original
    var buttons = this.props.desktopButtons.slice(0);
    var mobileButtons = this.props.mobileButtons;
    var top_buttons = [];
    var bottom_buttons = [];
    var dot_menu = [];
    var button, i, verticalButton;
    var how_many_buttons = this._howManyButtons();
    if (buttons.length >= how_many_buttons) {
      buttons.splice(how_many_buttons - 1, 0, {
        id: "dotdotdot-button",
        top: false,
        clickEvent: this._toggleDotMenu
      });
    }
    for (i = 0; i < buttons.length; i++) {
      button = buttons[i];
      verticalButton = (
        <ToolbarButton
          key={`${button.id} ${i}`}
          id={button.id}
          icon={button.icon}
          title={button.title}
          clickEvent={button.clickEvent}
          active={button.active}
          activeMethod={button.activeMethod}
          light={button.light}
          notificationCount={
            button.notificationCount > 0 && button.notificationCount
          }
        />
      );
      if (i < how_many_buttons) {
        bottom_buttons.push(verticalButton);
      } else {
        dot_menu.push(verticalButton);
      }
    }
    if (Fraction.Helpers.showWatkins) {
      top_buttons.push(
        <div className="watkinsicon" onClick={this._loadWatkins}>
          <Isvg src="/img/watkins_welcome.svg" />
        </div>
      );
    }

    return (
      <div aria-hidden={FractionStore.get()["modal-open"]} role="navigation">
        <div
          aria-hidden={!Fraction.Helpers.isSmallScreen()}
          id="mobile-toolbar"
          className="respond-mobile"
        >
          <div className="mobile-toolbar-inner">
            <button
              id="mobile-menu-button"
              aria-pressed="false"
              onClick={this._mobileMenuEvent}
              className="noButton mobile-toolbar-button menu-button"
            >
              {i18n.t("reader.buttons.main-menu")}
            </button>
            <div className="mobile-right">
              <button id="mobile-menu-title" className="noButton">
                {book.title}
              </button>
              <button
                id="mobile-search-button"
                aria-pressed="false"
                className="noButton mobile-toolbar-button"
                onClick={this._openSearch}
              >
                {i18n.t("reader.buttons.search-icon")}
              </button>
            </div>
          </div>
        </div>
        <VerticalToolbarDiv
          aria-hidden={Fraction.Helpers.isSmallScreen()}
          id="vertical-toolbar"
          className={"respond-desktop " + this.props.scrubber_expanded}
        >
          <div id="side-buttons">
            {top_buttons}
            {bottom_buttons}
          </div>

          <div id="dot-menu">{dot_menu}</div>
        </VerticalToolbarDiv>
        <ContextModal
          id="complete-account-reminder"
          menuId="complete-account-reminder"
          direction={Fraction.Helpers.isSmallScreen() ? "up" : "left"}
          alignLeft={Fraction.Helpers.isSmallScreen() ? false : 44}
          yOffset={-2}
          title={i18n.t("onboarding.access-more-features")}
          content={i18n.t("onboarding.get-started")}
          buttons={[
            {
              label: i18n.t("base.next"),
              click: this._removeMenu,
              color: "blue"
            }
          ]}
        />
        <ContextModal
          id="gps-lti-unavailable"
          menuId="gps-lti-unavailable"
          direction={Fraction.Helpers.isSmallScreen() ? "up" : "left"}
          alignLeft={Fraction.Helpers.isSmallScreen() ? false : 44}
          yOffset={-73}
          title={i18n.t("lti.gps.unavailable-title")}
          content={window.toHTML(
            i18n.t("lti.gain-access") +
              "<br /><br />" +
              i18n.t("lti.support", { supportURL: Fraction.Brand.Support.url })
          )}
          buttons={[]}
        />
      </div>
    );
  }

  // Returns the number of buttons to show in the sidebar
  // based on the current height
  _howManyButtons() {
    var buttonHeight = 36;
    var buttonMargin = 10;
    var inBetweenHeight = 10;
    return Math.floor(
      (this.props.window_height - inBetweenHeight) /
        (buttonHeight + buttonMargin)
    );
  }

  // show/hide the dot menu
  _toggleDotMenu() {
    $("#dot-menu").toggle();
  }
}

module.exports = VerticalToolbarContainer;
